import { AgentPromptDocumentTab } from "@/features/agents/agent-prompt-document-tab";
import { AGENT_USER_PROMPT_KEY } from "@/lib/types/control-plane-agents";

export function AgentUserTab() {
  return (
    <AgentPromptDocumentTab
      tabId="user"
      promptKey={AGENT_USER_PROMPT_KEY}
      title="USER.md"
      placeholder="Write the user profile markdown..."
    />
  );
}
